import store from "../store";

// Importación de Axios
import axios from "axios";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

// Planificación anual
export const getPlanificacionAnualCharter = async () => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/listAnnualPlanning`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const filterPlanificacionAnualCharter = async (filters) => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/listAnnualPlanning`,
      {
        filters
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;

    });

  return dataAux;
};

export const savePlanificacionAnualCharter = async (plans) => {
  let dataResponse;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/charter/storeAnnualPlanning`,
      {
        plans,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  return dataResponse;

};

export const listarPlanificacionAnualCharterDetalle = async (id) => {
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listaPlanificacionAnualDetalle/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const actualizarPlanificacionAnual = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/updateAnnualPlanning`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const eliminarServiciosPlanificacionAnualCharter = async (plans) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/deleteAnnualPlanningRoutes`,
    plans,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const eliminarServiciosPorRutaPlanificacionAnualCharter = async (plans) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/deleteAnnualPlanningRoutes`,
    plans,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const downloadReportePlanificacionAnualCharter = async (filters, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/reportAnnualPlanning`,
    {
      filters: filters
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

//*****************************************************************************//
//******************************planificacion semanal *************************//
//*****************************************************************************//
//listar p semanal
export const getPlanificacionSemanal = async () => {
  let dataAux = new Array();
  await axios.get(`${RUTA_SERVIDOR_BACKEND}/charter/listWeeklyPlanning`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const getPuertosPlanificacionSemanal = async (id) => {
  let dataAux = new Array();
  await axios.get(`${RUTA_SERVIDOR_BACKEND}/charter/listPortsByRegion/${id}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const crearPlanificacionSemanal = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/storeWeeklyPlanning`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const actualizarPlanificacionSemanal = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/updateWeeklyPlanning`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const eliminarPlanificacionSemanal = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/deleteWeeklyPlanning`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const filtrarPlanificacionSemanal = async (filters) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/listWeeklyPlanning`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const downloadReportePlanificacionSemanalCharter = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/reportWeeklyPlanning`,
    {
      filters: data
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

//*****************************************************************************//
//******************************Servicios**************************************//
//*****************************************************************************//
export const getServicios = async () => {
  let dataAux = new Array();
  await axios.get(`${RUTA_SERVIDOR_BACKEND}/charter/services/index`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const filtrarServicios = async (filters) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/services/index`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const guardarServicios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/services/store`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const actualizarServicios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/services/update`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const eliminarPuertoServicios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/services/deletePort`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const eliminarServicios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/services/delete`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const statusServicios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/services/updateStatus`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

//*****************************************************************************//
//****************************Itinerarios**************************************//
//*****************************************************************************//
export const getItinerarios = async () => {
  let dataAux = new Array();
  await axios.get(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/index`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const filtrarItinerarios = async (filters) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/index`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const buscarItinerarios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/search`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const guardarItinerarios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/store`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const actualizarItinerarios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/update`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const eliminarPuertoItinerarios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/deletePort`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const eliminarItinerarios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/delete`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const statusItinerarios = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/updateStatus`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const downloadReporteItinerariosCharter = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/itineraries/exportItineraries`,
    data,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

//*****************************************************************************//
//*****************************************************************************//
export const eliminarPlanificacionAnualCharter = async (plans) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/charter/deleteAnnualPlanning`,
      {
        plans
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, status: dataResponse });

  return dataAux[0];
};

// FPlanificación semanal
export const getPlanificacionSemanalCharter = async () => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarPlanificacionesSemanalCharter`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const savePlanificacionSemanalCharter = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarPlanificacionesSemanalCharter`,
      {
        data: data,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, status: dataResponse });

  return dataAux[0];
};

//Servicios
export const getServiciosCharter = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarServiciosCharter`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);







// Declaración por nave
export const getDeclaracionPorNave = async () => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/listarNavesDeclaradas`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const sendXMLContainer = async (id = '') => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/sendCharterContainer/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};


export const sendXMLPallet = async (id = '') => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/sendCharterPallet/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const cambiarEstadoDeclaracionPorNave = async (data) => {

  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/actualizarEstadoDeclaracion`, {
      "id_charter_itineraries": data.id_charter_itineraries,
      "status": data.status
    }, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};


// Bajo cubierta

export const getPalletsCharter = async (id = '') => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const createPalletsCharter = async (form) => {

  let respuesta;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/pallets`,
      {
        id_client: form.id_client,
        exporter_id: form.exporter_id,
        pol_id: form.pol_id,
        pod_id: form.pod_id,
        cant: form.cant,
        pallet_id: form.pallet_id,
        charter_product_id: form.charter_product_id,
        condition_id: form.condition_id,
        charter_itinerary_id: form.charter_itinerary_id,
        comment: form.comment
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(function ({ data }) {
      respuesta = data;
    })

    .catch(({ response }) => {
      respuesta = response;
    });

  dataAux.push({ data: respuesta });

  return dataAux[0];

};

export const getShipper = async (id) => {

  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/searchShipper/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;

};

export const actualizarPalletCharter = async (data) => {
  let dataAux = new Array();
  await axios.put(`${RUTA_SERVIDOR_BACKEND}/charter/pallets`,
    {
      "id": data.id,
      "id_client": data.id_client,
      "exporter_id": data.exporter_id,
      "pol_id": data.pol_id,
      "pod_id": data.pod_id,
      "cant": data.cant,
      "pallet_id": data.pallet_id,
      "charter_product_id": data.charter_product_id,
      "condition_id": data.condition_id,
      "charter_itinerary_id": data.charter_itinerary_id ?? null,
      "comment": data.comment,
      "embarked_cant": data.embarked_cant ?? null,
      "embarked_pallet_id": data.embarked_pallet_id ?? null
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const cancelarPalletCharter = async (id) => {

  let dataAux = new Array();
  await axios.delete(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(({ data }) => {
    dataAux = data;
  });

  return dataAux;

};

export const finalizarPalletCharter = async (data) => {

  let dataAux = new Array();
  await axios.put(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/accept`,
    {
      "id": data.id,
      "embarked_pallet_id": data.pallet_id,
      "embarked_cant": data.cantidad
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });

  return dataAux;

};


// Sobre cubierta

export const getContainersCharter = async (id) => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/containers/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {

      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const createContainerCharter = async (form) => {

  const { cant, comment, parameter, ventilation_type, container_temperature, container_ventilation, id_client, pol_id, pod_id, port_destination_id, charter_product_id,
    conditions_id, container_id, atmosphere_id, consolidation_zone_id, movement_type_id, charter_itinerary_id, exporter_id } = form;

  let respuesta;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/containers`,
      {
        cant,
        comment,
        parameter,
        ventilation_type,
        container_temperature,
        container_ventilation,
        id_client,
        pol_id,
        pod_id,
        port_destination_id,
        charter_product_id,
        conditions_id,
        container_id,
        atmosphere_id,
        consolidation_zone_id,
        movement_type_id,
        charter_itinerary_id,
        exporter_id
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(function ({ data }) {
      respuesta = data;
    })

    .catch(({ response }) => {
      respuesta = response;
    });

  dataAux.push({ data: respuesta });

  return dataAux[0];

};

export const finalizarContainerCharter = async (data) => {

  let dataAux = new Array();
  await axios.put(`${RUTA_SERVIDOR_BACKEND}/charter/containers/accept`,
    {
      "id": data.id,
      "embarked_container_id": data.container_id,
      "embarked_cant": data.cantidad
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });

  return dataAux;

};

export const downloadPDFDeclarados = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/charter-itinerary/generatePDF/${id}`,
      {
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(response => response);

export const downloadExcelPallets = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/export/${id}`,
      {
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(response => response);

export const downloadExcelContainer = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/containers/export/${id}`,
      {
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(response => response);

export const cancelarContainerCharter = async (id) => {

  let dataAux = new Array();
  await axios.delete(`${RUTA_SERVIDOR_BACKEND}/charter/containers/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(({ data }) => {
    dataAux = data;
  });

  return dataAux;

};

export const updateCBNContainerCharter = async (data) => {

  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/containers/update/cbn`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });

  return dataAux;

};

export const updateCBNPalletCharter = async (data) => {

  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/update/cbn`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });

  return dataAux;

};

export const actualizarContainerCharter = async (data) => {
  let dataAux = new Array();
  await axios.put(`${RUTA_SERVIDOR_BACKEND}/charter/containers`,
    {
      id: data.id,
      cant: data.cant,
      comment: data.comment,
      parameter: data.parameter,
      ventilation_type: data.ventilation_type,
      container_temperature: data.container_temperature,
      container_ventilation: data.container_ventilation,
      id_client: data.id_client,
      pol_id: data.pol_id,
      pod_id: data.pod_id,
      port_destination_id: data.port_destination_id,
      charter_product_id: data.charter_product_id,
      conditions_id: data.conditions_id,
      container_id: data.container_id,
      atmosphere_id: data.atmosphere_id,
      consolidation_zone_id: data.consolidation_zone_id,
      movement_type_id: data.movement_type_id,
      charter_itinerary_id: data.charter_itinerary_id,
      exporter_id: data.exporter_id
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });

  return dataAux;

};

export const getPalletFinished = async () => {

  const { data } = await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/finished`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

  return data;

};

export const getPallet = async id => {

  const { data } = await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/pallet/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

  return data;

}

export const getPalletFinishedFilter = async form => {

  const { data } = await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/finished`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;
};

export const getContainerFinishedFilter = async () => {

  const { data } = await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/containers/finished`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;
};

export const getContainer = async id => {

  const { data } = await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/container/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;
};

export const updateContainer = async form => {

  const { data } = await axios
    .put(`${RUTA_SERVIDOR_BACKEND}/charter/containers`, form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;
};

export const getContainerFinishedDataFilter = async form => {

  const { data } = await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/containers/finished`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;
};

export const downloadExcelPalletsFilter = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/pallets/finished/export`,
      form,
      {
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(response => response);

export const downloadExcelContainersFilter = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/containers/finished/export`,
      form,
      {
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(response => response);

export const filtrarDeclaracionesPorNave = async (form) => {

  let respuesta;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/listarNavesDeclaradas`,
      {
        "naviera_id": form.naviera_id,
        "ship_id": form.ship_id,
        "charter_route_id": form.charter_route_id,
        "week": form.week,
        "year": form.year
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(function ({ data }) {
      respuesta = data;
    })

    .catch(({ response }) => {
      respuesta = response;
    });

  dataAux.push({ data: respuesta });

  return dataAux[0];

};


export const getCharterSiEnviadas = async () => {

  store.state.loadingTable = true;

  const { data } = await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/charter/shippingInstructions/shippingEnviadas`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;

};

export const getCharterSiTemplates = async () => {

  store.state.loadingTable = true;

  const { data } = await axios.get(`${RUTA_SERVIDOR_BACKEND}/charter/shippingInstructions/shippingInstructionsTemplates`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;

};


export const filtrarCharterSiEnviadas = async (form) => {

  store.state.loadingTable = true;

  const { data } = await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/charter/shippingInstructions/shippingEnviadas`,
      {
        "id_shipping": form.id_shipping,
        "shipper": form.shipper,
        "id_naviera": form.id_naviera,
        "nave": form.nave,
        "viaje": form.viaje,
        "id_booking": form.id_booking,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

  return data;

}

export const getCharterSIPorEnviar = async () => {

  const { data } = await axios.get(`${RUTA_SERVIDOR_BACKEND}/charter/shippingInstructions/porEnviar`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    });

  return data;
};

export const getCharterSIPorEnviarForm = async form => {

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/shippingInstructions/porEnviar`,
    form,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    });

  return data;
};

export const getInitReporte = async () => {

  const { data } = await axios.get(`${RUTA_SERVIDOR_BACKEND}/charter/reporte`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    });

  return data ;
};

export const getGeneralReport = async form => {

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/charter/reporte`,
  form,
    {
      responseType: 'blob',
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    });

  return data ;
};